/* eslint-disable no-control-regex */
const countWords = (text) => {
  if (typeof text !== 'string') {
    return 0;
  }
  // eslint-disable-next-line no-control-regex
  let words = text.replace(/[^\x00-\xFF]/g, (c) => {
    const charCode = c.charCodeAt(0);

    // Removes ZERO WIDTH NO-BREAK SPACE and "General Punctation Chars"
    // http://www.unicodemap.org/range/40/General_Punctuation/
    if (charCode === 65279 || (charCode >= 0x2007 && charCode <= 0x206f)) {
      return '';
    }
    // Remove unicode spaces
    if (charCode === 0x00a0) {
      return '';
    }
    // hex charcode with 4 positions fixed(0 padding)
    return `0x${(charCode + 0x10000).toString(16).substr(-4).toUpperCase()}`;
  });

  words = words.replace(/&nbsp;/g, ''); // Remove &nbsp;
  words = words.replace(/\s\s+/g, ' '); // Remove double spaces
  words = words.replace(/(<[^>]*>)|([.,;:?!]+)/g, ' '); // HTML tags and punctuation

  // Removes other chars, except for "one letter words(Special Chars)"
  const charRegex =
    /\[.?\]|\{.?\}|([^\s\wàÀáÁåÅæÆèÈéÉÈíÍöÖøØőŐвВєЄжЖзЗиИйЙкКўЎяЯ]|_)/g;
  words = words.replace(charRegex, '').trim();

  if (words) {
    return words
      .split(/\s+/)
      .map((token) =>
        token.replace(/0x[0-9A-Fa-f]{4}/g, (c) => String.fromCharCode(+c))
      ).length;
  }

  return 0;
};

const getInitModel = (item) => {
  if (!Array.isArray(item)) {
    return item?.modelRef;
  }

  let model;
  if (Array.isArray(item) && item.some((m) => m.selected === true)) {
    let filter = item.filter((m) => m.selected === true);
    model = filter[0].modelRef;
  } else {
    model = item[0].modelRef;
  }
  return model;
};

const getInitFavorite = (item) => {
  if (!Array.isArray(item)) {
    return item?.is_favorite ?? false;
  }

  if (Array.isArray(item) && item.some((m) => m.selected === true)) {
    const selected = item.find((m) => m.selected === true);
    return selected?.is_favorite ?? false;
  }

  return item[0]?.is_favorite ?? false;
};

const truncateMessage = (message, searchTerm) => {
  if (typeof message !== 'string') {
    return message;
  }

  const parts = message.split(/(```[\s\S]*?```|`[^`]*`)/g);

  return parts
    .map((part) => {
      if (part.startsWith('```') || part.startsWith('`')) {
        return part;
      } else {
        return part.replace(
          new RegExp(`(${searchTerm})`, 'ig'),
          '<span style="color: orange; font-weight: bold;">$1</span>'
        );
      }
    })
    .join('');
};

const getInitMerge = (item) => {
  if (!Array.isArray(item)) {
    return 0;
  }

  let mergeItems;
  if (item.some((i) => i.merged)) {
    mergeItems = item.filter((i) => i.merged);
  }

  const index =
    mergeItems && mergeItems.length
      ? mergeItems.findIndex((i) => i.selected)
      : 0;

  return index !== -1 ? index : 0;
};

export {
  countWords,
  getInitFavorite,
  getInitMerge,
  getInitModel,
  truncateMessage,
};
